import { FunctionComponent } from "react";

import { useUser } from "#modules/users/view/useUser";

import classes from "./Header.module.css";

export const Avatar: FunctionComponent = () => {
  const { user } = useUser();

  const firstLetterToUppercase = (str: string | undefined): string =>
    str ? str.charAt(0).toUpperCase() : "";

  const letters = `${firstLetterToUppercase(
    user?.firstName,
  )}${firstLetterToUppercase(user?.lastName)}`;

  return <div className={classes.avatar}>{letters}</div>;
};
